import { render, staticRenderFns } from "./SectionConfigModal.vue?vue&type=template&id=55577391&scoped=true&"
import script from "./SectionConfigModal.vue?vue&type=script&lang=js&"
export * from "./SectionConfigModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55577391",
  null
  
)

export default component.exports